
export enum TransactionCartMode {
  createOrEdit = 0,
  view = 1
}
